export const environment = {
	production: false,
	envName: 'dev-us',
	cognitoConfig: {
		mandatorySignIn: true,
		region: 'us-east-1',
		userPoolId: 'us-east-1_y73MBhPk8',
		userPoolWebClientId: '3voo6gptshiq696tkre7fgdq5h',
		oauth: {
			domain: 'mydomain3.auth.us-east-1.amazoncognito.com',
			scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
			redirectSignIn: 'https://osm.dev.myosmtech.com/home',
			redirectSignOut: 'https://osm.dev.myosmtech.com/home',
			responseType: 'code'
		}
	},
	// Dev US East API Endpoint
	baseUrl: 'https://q2q37adaxi.execute-api.us-east-1.amazonaws.com/osm-devuseast1-blue-apistage'
};
